import { useState } from 'react'
import { Link } from 'react-router-dom'
import { WaitlistForm } from '../components/WaitlistForm.tsx'
import { USE_MOCKUP_COPY, mockupCopy, currentCopy } from '../content/homeContent.ts'

const content = USE_MOCKUP_COPY ? mockupCopy : currentCopy

const WhatsAppIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.04 2A9.9 9.9 0 0 0 2.13 11.9c0 1.75.46 3.45 1.32 4.95L2 22l5.3-1.38a9.9 9.9 0 0 0 4.74 1.2h.01A9.9 9.9 0 0 0 22 11.9 9.9 9.9 0 0 0 12.04 2Zm0 18.03h-.01a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.1.81.83-3.02-.2-.31a8.2 8.2 0 1 1 7.16 4.05Zm4.5-6.14c-.25-.12-1.46-.72-1.68-.8-.23-.09-.39-.13-.56.12s-.64.8-.79.97c-.14.16-.29.18-.54.06a6.7 6.7 0 0 1-1.97-1.22 7.4 7.4 0 0 1-1.36-1.7c-.14-.24 0-.37.11-.49.11-.11.25-.29.37-.43.12-.14.16-.24.25-.41.08-.16.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.41-.56-.42h-.48c-.16 0-.43.06-.65.31-.22.24-.85.83-.85 2.02 0 1.19.87 2.35.99 2.51.12.16 1.7 2.6 4.13 3.64.58.25 1.03.4 1.38.51.58.19 1.1.16 1.52.1.46-.07 1.46-.6 1.67-1.18.2-.58.2-1.07.14-1.18-.06-.1-.22-.16-.47-.28Z"/>
  </svg>
)

export default function Home() {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false)

  const handleWaitlistSuccess = (data: any) => {
    console.log('Waitlist signup:', data)
    setShowWaitlistModal(false)
  }

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        style={{
          padding: 'var(--space-8) 20px var(--space-8)',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 'var(--space-8)',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: 1, minWidth: '290px' }}>
          {content.hero.tag && (
            <span className="tag tag-outline" style={{ marginBottom: '14px' }}>
              {content.hero.tag}
            </span>
          )}
          <h1
            style={{
              fontSize: 'clamp(30px, 5vw, 46px)',
              lineHeight: 1.04,
              margin: '8px 0 16px'
            }}
          >
            {content.hero.headline}
          </h1>
          <p
            style={{
              fontSize: '17px',
              maxWidth: '460px',
              margin: '0 0 24px',
              color: 'var(--color-neutral-800)'
            }}
          >
            {content.hero.subtitle}
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            <Link
              to="/contact"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '9px',
                background: '#25D366',
                color: '#062b16',
                border: 0,
                padding: '14px 20px',
                fontFamily: 'var(--font-heading)',
                fontWeight: 600,
                fontSize: '16px',
                cursor: 'pointer',
                textDecoration: 'none'
              }}
            >
              <WhatsAppIcon />
              Message us on WhatsApp
            </Link>
            <button
              className="btn btn-secondary"
              style={{ minHeight: '52px', fontSize: '16px', padding: '0 20px' }}
              onClick={() => setShowWaitlistModal(true)}
            >
              Join the waitlist
            </button>
          </div>
          {content.hero.ctaNote && (
            <p className="text-muted" style={{ fontSize: '13px', margin: '16px 0 0' }}>
              {content.hero.ctaNote}
            </p>
          )}
        </div>
        <div
          className="blueprint strip"
          style={{
            flex: 1,
            minWidth: '280px',
            height: '360px',
            display: 'grid',
            placeItems: 'center'
          }}
        >
          <i className="corner tl"></i>
          <i className="corner tr"></i>
          <i className="corner bl"></i>
          <i className="corner br"></i>
          <span
            style={{
              fontFamily: 'monospace',
              fontSize: '12px',
              color: 'var(--color-accent-800)',
              background: 'var(--color-bg)',
              padding: '6px 12px'
            }}
          >
            product shot — TALLY on a tablet at the counter
          </span>
        </div>
      </section>

      {/* Problem Section */}
      <section style={{ padding: 'var(--space-8) 20px', borderTop: '1px solid var(--color-divider)' }}>
        <div style={{ maxWidth: '760px' }}>
          {content.problem.kicker && (
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                color: 'var(--color-accent)'
              }}
            >
              {content.problem.kicker}
            </span>
          )}
          <h2 style={{ fontSize: 'clamp(24px, 4vw, 34px)', margin: '8px 0 14px' }}>
            {content.problem.headline}
          </h2>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '14px',
            marginTop: 'var(--space-4)'
          }}
        >
          {content.problem.cards.map((card, index) => (
            <div
              key={index}
              style={{
                border: '1px solid var(--color-divider)',
                padding: 'var(--space-4)'
              }}
            >
              <h4 style={{ margin: '0 0 6px' }}>{card.title}</h4>
              <p style={{ margin: 0, fontSize: '14px', color: 'var(--color-neutral-800)' }}>
                {card.body}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" style={{ padding: 'var(--space-8) 20px', borderTop: '1px solid var(--color-divider)' }}>
        <div style={{ maxWidth: '760px' }}>
          {content.benefits.kicker && (
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                color: 'var(--color-accent)'
              }}
            >
              {content.benefits.kicker}
            </span>
          )}
          <h2 style={{ fontSize: 'clamp(24px, 4vw, 34px)', margin: '8px 0 6px' }}>
            {content.benefits.headline}
          </h2>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: '14px',
            marginTop: 'var(--space-6)'
          }}
        >
          {content.benefits.items.map((benefit, index) => (
            <div
              key={index}
              className="blueprint"
              style={{ padding: 'var(--space-4)' }}
            >
              <i className="corner tl"></i>
              <i className="corner tr"></i>
              <i className="corner bl"></i>
              <i className="corner br"></i>
              {benefit.n && (
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    display: 'grid',
                    placeItems: 'center',
                    background: 'var(--color-accent-100)',
                    color: 'var(--color-accent-800)',
                    marginBottom: '12px',
                    fontFamily: 'var(--font-heading)',
                    fontWeight: 600
                  }}
                >
                  {benefit.n}
                </div>
              )}
              <h4 style={{ margin: '0 0 6px' }}>{benefit.title}</h4>
              <p style={{ margin: 0, fontSize: '14px', color: 'var(--color-neutral-800)' }}>
                {benefit.body}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Works Offline Beat */}
      <section
        style={{
          padding: 'var(--space-8) 20px',
          background: 'var(--color-accent-900)',
          color: 'var(--color-bg)',
          marginTop: 0
        }}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-6)', alignItems: 'center' }}>
          <div style={{ flex: 1, minWidth: '280px' }}>
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                opacity: .7
              }}
            >
              {content.offline.kicker}
            </span>
            <h2 style={{ fontSize: 'clamp(26px, 4.5vw, 40px)', margin: '10px 0 14px', color: 'var(--color-bg)' }}>
              {content.offline.headline}
            </h2>
            <p style={{ fontSize: '16px', maxWidth: '440px', margin: 0, opacity: .85 }}>
              {content.offline.body}
            </p>
          </div>
          <div
            className="blueprint strip"
            style={{
              flex: 1,
              minWidth: '260px',
              height: '230px',
              display: 'grid',
              placeItems: 'center',
              borderColor: 'color-mix(in srgb, var(--color-bg) 30%, transparent)'
            }}
          >
            <i className="corner tl"></i>
            <i className="corner tr"></i>
            <i className="corner bl"></i>
            <i className="corner br"></i>
            <span
              style={{
                fontFamily: 'monospace',
                fontSize: '12px',
                color: 'var(--color-bg)',
                background: 'var(--color-accent-900)',
                padding: '6px 12px'
              }}
            >
              illustration — "saved on device / syncs later"
            </span>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" style={{ padding: 'var(--space-8) 20px', borderTop: '1px solid var(--color-divider)' }}>
        <div style={{ maxWidth: '760px' }}>
          {content.howItWorks.kicker && (
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                color: 'var(--color-accent)'
              }}
            >
              {content.howItWorks.kicker}
            </span>
          )}
          <h2 style={{ fontSize: 'clamp(24px, 4vw, 34px)', margin: '8px 0 6px' }}>
            {content.howItWorks.headline}
          </h2>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: '14px',
            marginTop: 'var(--space-6)'
          }}
        >
          {content.howItWorks.steps.map((step, index) => (
            <div
              key={index}
              style={{
                padding: 'var(--space-4)',
                borderTop: '3px solid var(--color-accent)'
              }}
            >
              <div
                style={{
                  fontFamily: 'var(--font-heading)',
                  fontWeight: 600,
                  fontSize: '44px',
                  lineHeight: 1,
                  color: 'var(--color-accent-300)'
                }}
              >
                {step.n}
              </div>
              <h4 style={{ margin: '10px 0 6px' }}>{step.title}</h4>
              <p style={{ margin: 0, fontSize: '14px', color: 'var(--color-neutral-800)' }}>
                {step.body}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Who It's For Section */}
      <section style={{ padding: 'var(--space-8) 20px', borderTop: '1px solid var(--color-divider)' }}>
        <div style={{ maxWidth: '760px' }}>
          {content.whoItsFor.kicker && (
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                color: 'var(--color-accent)'
              }}
            >
              {content.whoItsFor.kicker}
            </span>
          )}
          <h2 style={{ fontSize: 'clamp(24px, 4vw, 34px)', margin: '8px 0 6px' }}>
            {content.whoItsFor.headline}
          </h2>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: '14px',
            marginTop: 'var(--space-6)'
          }}
        >
          {content.whoItsFor.cards.map((card, index) => (
            card.isComing ? (
              <div
                key={index}
                style={{
                  padding: 'var(--space-6)',
                  border: '1px dashed var(--color-divider)',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center'
                }}
              >
                <h3 style={{ margin: '0 0 6px', color: 'var(--color-neutral-600)' }}>{card.title}</h3>
                <p style={{ margin: 0, fontSize: '15px', color: 'var(--color-neutral-600)' }}>{card.body}</p>
              </div>
            ) : (
              <div
                key={index}
                className="blueprint"
                style={{ padding: 'var(--space-6)' }}
              >
                <i className="corner tl"></i>
                <i className="corner tr"></i>
                <i className="corner bl"></i>
                <i className="corner br"></i>
                <h3 style={{ margin: '0 0 6px' }}>{card.title}</h3>
                <p style={{ margin: 0, fontSize: '15px', color: 'var(--color-neutral-800)' }}>{card.body}</p>
              </div>
            )
          ))}
        </div>
      </section>

      {/* Trust Section */}
      <section style={{ padding: 'var(--space-8) 20px', borderTop: '1px solid var(--color-divider)', textAlign: 'center' }}>
        <span
          style={{
            fontSize: '12px',
            letterSpacing: '.12em',
            textTransform: 'uppercase',
            color: 'var(--color-accent)'
          }}
        >
          {content.trust.kicker}
        </span>
        <h2 style={{ fontSize: 'clamp(22px, 3.5vw, 30px)', margin: '8px 0 var(--space-6)' }}>
          {content.trust.headline}
        </h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '14px', justifyContent: 'center' }}>
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="blueprint strip"
              style={{
                width: '150px',
                height: '64px',
                display: 'grid',
                placeItems: 'center'
              }}
            >
              <i className="corner tl"></i>
              <i className="corner tr"></i>
              <i className="corner bl"></i>
              <i className="corner br"></i>
              <span
                style={{
                  fontFamily: 'monospace',
                  fontSize: '10px',
                  color: 'var(--color-accent-800)',
                  background: 'var(--color-bg)',
                  padding: '3px 6px'
                }}
              >
                logo
              </span>
            </div>
          ))}
        </div>
        <p className="text-muted" style={{ fontSize: '12px', marginTop: '14px' }}>
          Testimonials & partner logos — placeholder for launch
        </p>
      </section>

      {/* FAQ Section */}
      <section style={{ padding: 'var(--space-8) 20px', borderTop: '1px solid var(--color-divider)' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(24px, 4vw, 34px)', margin: '0 0 var(--space-6)', textAlign: 'center' }}>
            {content.faq.headline}
          </h2>
          {content.faq.items.map((faq, index) => (
            <div
              key={index}
              style={{
                borderBottom: '1px solid var(--color-divider)',
                padding: 'var(--space-4) 0'
              }}
            >
              <h4 style={{ margin: '0 0 6px' }}>{faq.q}</h4>
              <p style={{ margin: 0, fontSize: '15px', color: 'var(--color-neutral-800)' }}>
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA Section */}
      <section
        style={{
          padding: 'var(--space-8) 20px',
          background: 'var(--color-accent-900)',
          color: 'var(--color-bg)',
          textAlign: 'center'
        }}
      >
        <h2 style={{ fontSize: 'clamp(26px, 4.5vw, 40px)', margin: '0 0 12px', color: 'var(--color-bg)' }}>
          {content.finalCta.headline}
        </h2>
        <p style={{ fontSize: '16px', opacity: .85, maxWidth: '440px', margin: '0 auto 24px' }}>
          {content.finalCta.body}
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
          <Link
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '9px',
              background: '#25D366',
              color: '#062b16',
              border: 0,
              padding: '14px 22px',
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              fontSize: '16px',
              cursor: 'pointer',
              textDecoration: 'none'
            }}
          >
            <WhatsAppIcon />
            Book a demo
          </Link>
          <button
            style={{
              minHeight: '52px',
              fontSize: '16px',
              padding: '0 22px',
              background: 'transparent',
              border: '1px solid color-mix(in srgb, var(--color-bg) 45%, transparent)',
              color: 'var(--color-bg)',
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              cursor: 'pointer'
            }}
            onClick={() => setShowWaitlistModal(true)}
          >
            Join the waitlist
          </button>
        </div>
      </section>

      {/* Waitlist Modal */}
      {showWaitlistModal && (
        <div
          className="dialog-backdrop"
          onClick={() => setShowWaitlistModal(false)}
        >
          <div
            className="blueprint"
            style={{
              width: 'min(460px, 100%)',
              padding: 'var(--space-8)',
              background: 'var(--color-bg)',
              boxShadow: 'var(--shadow-lg)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <i className="corner tl"></i>
            <i className="corner tr"></i>
            <i className="corner bl"></i>
            <i className="corner br"></i>
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                color: 'var(--color-accent)'
              }}
            >
              Join the waitlist
            </span>
            <h2 style={{ margin: '8px 0 8px' }}>Not ready yet? Stay in the loop.</h2>
            <p style={{ fontSize: '15px', color: 'var(--color-neutral-800)', margin: '0 0 var(--space-4)' }}>
              Drop your name and number. We'll reach out when we're setting up shops near you.
            </p>
            <WaitlistForm
              onSuccess={handleWaitlistSuccess}
            />
          </div>
        </div>
      )}
    </div>
  )
}
